import Swiper from "swiper";
import { EffectFade, Thumbs } from "swiper/modules";

export default class TabsSlider {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.tabsThumbSwiper = new Swiper("[js-tabs-thumbs-slider]", {
			slidesPerView: "auto",
			freeMode: true,
			watchSlidesProgress: true,
		});

		this.tabsSwiper = new Swiper("[js-tabs-slider]", {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			modules: [Thumbs, EffectFade],
			thumbs: {
				swiper: this.tabsThumbSwiper,
			},
		});
	}
}
